module.exports = __webpack_public_path__ + "static/media/checkmark_circle.858a2a0b.svg";